import React from "react";
import RoleProvider from "./context/Provider";
import RoleContent from "./RoleContent";
import RoleDrawer, { RoleDrawerProps } from "./RoleDrawer";

type RoleProps = RoleDrawerProps & { roleId?: number };

const Role = ({ open, onClose, roleId }: RoleProps): React.JSX.Element => {
  return (
    <RoleProvider onCancel={onClose} roleId={roleId}>
      <RoleDrawer open={open} onClose={onClose}>
        <RoleContent />
      </RoleDrawer>
    </RoleProvider>
  );
};

export default Role;
